module.exports = __webpack_public_path__ + "cfef2d79646670e7d96db0090408dd71.png";